import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { WarrantyLabor } from '../../Models/WarrantyLabor';

export default function WarrantyLaborTable({
  data,
  editWarrantyLabor,
  deleteWarrantyLabor,
}: {
  data: WarrantyLabor[];
  editWarrantyLabor: (labor: WarrantyLabor) => void;
  deleteWarrantyLabor(labor: WarrantyLabor): void;
}) {
  const columnHelper = createColumnHelper<WarrantyLabor>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => editWarrantyLabor(info.row.original)}
          >
            <HiPencilAlt />
          </button>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteWarrantyLabor(info.row.original)}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.hours, {
      id: 'hours',
      header: 'Hours',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.rate, {
      id: 'rate',
      header: 'Rate',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.total, {
      id: 'total',
      header: 'Total',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.description, {
      id: 'description',
      header: 'Description',
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
          showPagination={false}
        />
      </div>
    </>
  );
}
